/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Bubble_GoInputs */

const en_of_landing_bubble_go = /** @type {(inputs: Of_Landing_Bubble_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let's go!`)
};

const id_of_landing_bubble_go = /** @type {(inputs: Of_Landing_Bubble_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yuk mulai!`)
};

/**
* | output |
* | --- |
* | "Let's go!" |
*
* @param {Of_Landing_Bubble_GoInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_bubble_go = /** @type {((inputs?: Of_Landing_Bubble_GoInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Bubble_GoInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_bubble_go(inputs)
	return en_of_landing_bubble_go(inputs)
});